var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-result',{attrs:{"status":"404","title":_vm.title,"sub-title":"Sorry, the page you visited does not exist."}})}
var staticRenderFns = []

export { render, staticRenderFns }